import { render, staticRenderFns } from "./setTime.vue?vue&type=template&id=60cf98c9&scoped=true"
import script from "./setTime.vue?vue&type=script&lang=js"
export * from "./setTime.vue?vue&type=script&lang=js"
import style0 from "./setTime.vue?vue&type=style&index=0&id=60cf98c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf98c9",
  null
  
)

export default component.exports